<template>
  <!-- Free access wrapper -->
  <div>
    <!-- ===== SUBSCRIPTION_FEATURE_START =====
    Subscription status checks temporarily disabled
    All users have free access
    To re-enable: Change v-if="false && showSubscriptionWidget" to v-if="showSubscriptionWidget" below
    ===== -->
    <div v-if="false && showSubscriptionWidget" class="subscription-widget-container"> <!-- Set to false to disable subscription widget -->
      <!-- Loading State -->
    <div v-if="loading" class="widget-card">
      <div class="skeleton-loader">
        <div class="skeleton-header"></div>
        <div class="skeleton-value"></div>
        <div class="skeleton-subtitle"></div>
      </div>
    </div>


    <!-- Past Due Subscription Widget -->
    <div v-else-if="subscription && subscription.status === 'past_due'" class="widget-card subscription-warning">
      <div class="widget-header">
        <div class="widget-title">
          <svg class="title-icon warning" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          Payment Required
        </div>
        <div class="widget-change negative">Past Due</div>
      </div>
      <div class="widget-value">Action Needed</div>
      <div class="widget-subtitle">
        Update payment method to restore access
      </div>
      <button class="widget-view-btn warning" @click="openCustomerPortal" title="Update Payment">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
          <line x1="1" y1="10" x2="23" y2="10"/>
        </svg>
      </button>
    </div>

    <!-- Canceled Subscription Widget -->
    <div v-else-if="subscription && subscription.status === 'canceled'" class="widget-card subscription-canceled">
      <div class="widget-header">
        <div class="widget-title">
          <svg class="title-icon canceled" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
          Subscription Canceled
        </div>
        <div class="widget-change negative">Inactive</div>
      </div>
      <div class="widget-value">Canceled</div>
      <div class="widget-subtitle">
        Reactivate to restore full access
      </div>
      <button class="widget-view-btn" @click="reactivateSubscription" title="Reactivate">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="23 4 23 10 17 10"/>
          <path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/>
        </svg>
      </button>
    </div>

    <!-- No Subscription - Plan Selection -->
    <div v-else class="no-subscription-section">
      <!-- Get Started Widget -->
      <div class="widget-card get-started">
        <div class="widget-header">
          <div class="widget-title">
            <svg class="title-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
            </svg>
            Get Started
          </div>
        </div>
        <div class="widget-value">Choose Plan</div>
        <div class="widget-subtitle">
          Select a subscription to unlock all features
        </div>
      </div>

      <!-- Plan Cards Grid -->
      <div class="plans-grid">
        <!-- Monthly Plan -->
        <div class="plan-card" @click="selectPlan('monthly')">
          <div class="plan-header">
            <div class="plan-title">Monthly</div>
            <div class="plan-badge">Flexible</div>
          </div>
          <div class="plan-pricing">
            <span class="currency">$</span>
            <span class="amount">10</span>
            <span class="period">/month</span>
          </div>
          <div class="plan-features">
            <div class="feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              All Features Included
            </div>
            <div class="feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              Unlimited Grid Scans
            </div>
            <div class="feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              Cancel Anytime
            </div>
          </div>
          <button class="plan-select-btn">
            Select Monthly
          </button>
        </div>

        <!-- Yearly Plan -->
        <div class="plan-card featured" @click="selectPlan('yearly')">
          <div class="plan-header">
            <div class="plan-title">Yearly</div>
            <div class="plan-badge featured">Best Value</div>
          </div>
          <div class="plan-pricing">
            <span class="currency">$</span>
            <span class="amount">120</span>
            <span class="period">/year</span>
          </div>
          <div class="plan-features">
            <div class="feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              All Features Included
            </div>
            <div class="feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              Save $120 per year
            </div>
            <div class="feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              Priority Support
            </div>
          </div>
          <button class="plan-select-btn featured">
            Select Yearly
          </button>
        </div>
      </div>
    </div>
    </div>
    <!-- ===== SUBSCRIPTION_FEATURE_END ===== -->

    <!-- Component returns empty div for free access -->
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SubscriptionStatus',
  data() {
    return {
      loading: true,
      subscription: null,
      error: null
    };
  },
  computed: {
    showSubscriptionWidget() {
      /* ===== SUBSCRIPTION_FEATURE_START ===== */
      // Show widget ONLY if:
      // 1. Still loading (show skeleton)
      // 2. No subscription exists at all
      // 3. Subscription status is NOT 'active' or 'trialing'

      // First check if we have user data in store
      // const user = this.$store.state.auth.user;

      // If user has active subscription from store, hide widget immediately
      // if (user && user.has_active_subscription) {
      //   return false;
      // }

      // Show loading state
      // if (this.loading) {
      //   return true;
      // }

      // No subscription at all
      // if (!this.subscription) {
      //   return true;
      // }

      // Has subscription but it's not active or trialing
      // const inactiveStatuses = ['past_due', 'canceled', 'unpaid', 'incomplete', 'incomplete_expired'];
      // return inactiveStatuses.includes(this.subscription.status);
      /* ===== SUBSCRIPTION_FEATURE_END ===== */

      // Free access for all - never show subscription widget
      return false;
    }
  },
  mounted() {
    /* ===== SUBSCRIPTION_FEATURE_START ===== */
    // Only fetch if we don't have user data or if user doesn't have active subscription
    // const user = this.$store.state.auth.user;
    // if (!user || !user.has_active_subscription) {
    //   this.fetchSubscriptionStatus();
    // } else {
    //   // If user has active subscription, no need to fetch or show widget
    //   this.loading = false;
    // }
    /* ===== SUBSCRIPTION_FEATURE_END ===== */

    // Free access - no need to fetch subscription status
    this.loading = false;
  },
  methods: {
    async fetchSubscriptionStatus() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_ENDPOINT}/api/subscriptions/subscription`,
          {
            headers: {
              'Authorization': `Bearer ${(this.$store.getters['auth/jwt'] || this.$store.getters['auth/accessToken'])}`
            }
          }
        );

        if (response.data.hasSubscription) {
          this.subscription = response.data.subscription;
        }
      } catch (error) {
        console.error('Error fetching subscription:', error);
        this.error = 'Unable to load subscription status';
      } finally {
        this.loading = false;
      }
    },

    async selectPlan(planType) {
      const planName = planType === 'monthly' ? 'Monthly ($10/month)' : 'Yearly ($120/year)';
      
      // Show confirmation dialog
      const result = await this.$swal({
        title: 'Subscribe to ' + planName + ' Plan?',
        text: 'You will be redirected to our secure payment page to complete your subscription.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3ebb80',
        cancelButtonColor: '#757B89',
        confirmButtonText: 'Yes, proceed to payment',
        cancelButtonText: 'Cancel'
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/api/subscriptions/create-checkout-session`,
          { planType },
          {
            headers: {
              'Authorization': `Bearer ${(this.$store.getters['auth/jwt'] || this.$store.getters['auth/accessToken'])}`
            }
          }
        );

        if (response.data.url) {
          this.$swal({
            icon: 'success',
            title: 'Redirecting...',
            text: 'Taking you to secure checkout',
            timer: 1500,
            showConfirmButton: false
          });
          setTimeout(() => {
            window.location.href = response.data.url;
          }, 1500);
        }
      } catch (error) {
        console.error('Error creating checkout session:', error);
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Unable to start checkout process. Please try again.'
        });
      }
    },

    async openCustomerPortal() {
      // Show information dialog
      const result = await this.$swal({
        title: 'Open Customer Portal?',
        html: 'You will be redirected to the secure customer portal where you can:<br><br>' +
              '• Update payment methods<br>' +
              '• Download invoices<br>' +
              '• Cancel or change your subscription<br>' +
              '• View billing history',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3ebb80',
        cancelButtonColor: '#757B89',
        confirmButtonText: 'Open Portal',
        cancelButtonText: 'Cancel'
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_ENDPOINT}/api/subscriptions/portal-url`,
          {
            headers: {
              'Authorization': `Bearer ${(this.$store.getters['auth/jwt'] || this.$store.getters['auth/accessToken'])}`
            }
          }
        );

        if (response.data.url) {
          window.open(response.data.url, '_blank');
        }
      } catch (error) {
        console.error('Error opening customer portal:', error);
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Unable to open customer portal. Please try again.'
        });
      }
    },

    async reactivateSubscription() {
      // Show confirmation dialog
      const result = await this.$swal({
        title: 'Reactivate Subscription?',
        text: 'Your subscription will be reactivated and billing will resume at the end of your current period.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3ebb80',
        cancelButtonColor: '#757B89',
        confirmButtonText: 'Yes, reactivate',
        cancelButtonText: 'Cancel'
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/api/subscriptions/reactivate`,
          {},
          {
            headers: {
              'Authorization': `Bearer ${(this.$store.getters['auth/jwt'] || this.$store.getters['auth/accessToken'])}`
            }
          }
        );

        if (response.data.success) {
          this.$swal({
            icon: 'success',
            title: 'Success',
            text: 'Your subscription has been reactivated!'
          });
          // Update user profile in store
          await this.$store.dispatch('auth/fetchUserProfile');
          this.fetchSubscriptionStatus();
        }
      } catch (error) {
        console.error('Error reactivating subscription:', error);
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Unable to reactivate subscription. Please try again.'
        });
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    }
  }
};
</script>

<style scoped>
/* Container */
.subscription-widget-container {
  margin-bottom: 24px;
}

/* Widget Card - Matching Agency Dashboard Style */
.widget-card {
  background: #f9fafb;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #f3f4f6;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
  margin-bottom: 20px;
}

.widget-card:hover {
  transform: translateY(-2px);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
  background: #ffffff;
}

/* Widget Header */
.widget-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.widget-title {
  font-family: 'Rubik', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #757B89;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-icon {
  width: 18px;
  height: 18px;
  color: #3ebb80;
}

.title-icon.warning {
  color: #f59e0b;
}

.title-icon.canceled {
  color: #ef4444;
}

/* Widget Change Badge */
.widget-change {
  font-family: 'Rubik', sans-serif;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.widget-change.positive {
  background: rgba(62, 187, 128, 0.1);
  color: #3ebb80;
}

.widget-change.negative {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

/* Widget Value */
.widget-value {
  font-family: 'Rubik', sans-serif;
  font-size: 2.25rem;
  font-weight: 600;
  color: #19233A;
  margin-bottom: 8px;
  line-height: 1.2;
}

/* Widget Subtitle */
.widget-subtitle {
  font-family: 'Rubik', sans-serif;
  font-size: 14px;
  color: #757B89;
}

/* Widget View Button */
.widget-view-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(62, 187, 128, 0.1);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.widget-view-btn:hover {
  background: rgba(62, 187, 128, 0.2);
  transform: scale(1.1);
}

.widget-view-btn.warning {
  background: rgba(245, 158, 11, 0.1);
}

.widget-view-btn.warning:hover {
  background: rgba(245, 158, 11, 0.2);
}

.widget-view-btn svg {
  width: 18px;
  height: 18px;
  color: #3ebb80;
}

.widget-view-btn.warning svg {
  color: #f59e0b;
}

/* Plans Grid */
.no-subscription-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

/* Plan Card */
.plan-card {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0px 2px 20px 0px rgba(62, 187, 128, 0.1);
  border: 1px solid #E5E7EB;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
}

.plan-card:hover {
  transform: translateY(-4px);
  box-shadow: 0px 4px 30px 0px rgba(62, 187, 128, 0.2);
  border-color: #3ebb80;
}

.plan-card.featured {
  border: 2px solid #3ebb80;
  background: linear-gradient(135deg, #FFFFFF 0%, #f0fdf4 100%);
}

/* Plan Header */
.plan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.plan-title {
  font-family: 'Rubik', sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #19233A;
}

.plan-badge {
  background: #f3f4f6;
  color: #757B89;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.plan-badge.featured {
  background: linear-gradient(135deg, #3ebb80 0%, #2d9460 100%);
  color: white;
}

/* Plan Pricing */
.plan-pricing {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f3f4f6;
}

.plan-pricing .currency {
  font-family: 'Rubik', sans-serif;
  font-size: 20px;
  color: #757B89;
  margin-right: 4px;
  font-weight: 400;
}

.plan-pricing .amount {
  font-family: 'Rubik', sans-serif;
  font-size: 48px;
  font-weight: 700;
  color: #19233A;
}

.plan-pricing .period {
  font-family: 'Rubik', sans-serif;
  font-size: 16px;
  color: #757B89;
  margin-left: 8px;
  font-weight: 400;
}

/* Plan Features */
.plan-features {
  margin-bottom: 32px;
}

.feature {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  font-family: 'Rubik', sans-serif;
  font-size: 14px;
  color: #4B5563;
}

.feature svg {
  width: 16px;
  height: 16px;
  color: #3ebb80;
  flex-shrink: 0;
}

/* Plan Select Button */
.plan-select-btn {
  width: 100%;
  padding: 14px 24px;
  border-radius: 8px;
  font-family: 'Rubik', sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid #E5E7EB;
  background: white;
  color: #19233A;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.plan-select-btn:hover {
  background: #f9fafb;
  border-color: #3ebb80;
  color: #3ebb80;
  transform: translateY(-1px);
}

.plan-select-btn.featured {
  background: linear-gradient(135deg, #3ebb80 0%, #2d9460 100%);
  color: white;
  border: none;
}

.plan-select-btn.featured:hover {
  transform: translateY(-2px);
  box-shadow: 0px 4px 20px 0px rgba(62, 187, 128, 0.4);
}

/* Loading Skeleton */
.skeleton-loader {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.skeleton-header {
  height: 14px;
  background: #e5e7eb;
  border-radius: 4px;
  margin-bottom: 16px;
  width: 40%;
}

.skeleton-value {
  height: 36px;
  background: #e5e7eb;
  border-radius: 4px;
  margin-bottom: 8px;
  width: 60%;
}

.skeleton-subtitle {
  height: 14px;
  background: #e5e7eb;
  border-radius: 4px;
  width: 80%;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Responsive Design */
@media (max-width: 768px) {
  .plans-grid {
    grid-template-columns: 1fr;
  }
  
  .widget-value {
    font-size: 1.75rem;
  }
  
  .plan-pricing .amount {
    font-size: 36px;
  }
  
  .widget-card {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .widget-card {
    padding: 16px;
  }
  
  .widget-value {
    font-size: 1.5rem;
  }
}
</style>